import { render } from "./PatientTherapyFromDrug.vue?vue&type=template&id=54e3dc9e"
import script from "./PatientTherapyFromDrug.vue?vue&type=script&lang=js"
export * from "./PatientTherapyFromDrug.vue?vue&type=script&lang=js"

import "./PatientTherapyFromDrug.vue?vue&type=style&index=0&id=54e3dc9e&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/DACY_Demo_Server/kbdemo_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__